import {
    initializeFiltersFromDOM,
    createSearchHandler,
    createSortHandler,
    buildBlogBlockFilterUrl
} from './ajax-filters-shared.js';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.blog-with-filters').forEach((section) => {
        const searchInput = section.querySelector('.resource-search');
        const clearBtn = section.querySelector('.clear-search');
        const popularBtn = section.querySelector('.most-popular');
        const recentBtn = section.querySelector('.most-recent');

        let filters = {
            topic: null,
            tag: null,
            date: null,
            search: '',
            sort: 'recent',
        };

        initializeFiltersFromDOM(section, filters);

        const urlParams = new URLSearchParams(window.location.search);

        ['topic', 'tag', 'date', 'search', 'sort'].forEach((key) => {
            if (urlParams.has(key)) {
                filters[key] = urlParams.get(key);
            }
        });

        if (searchInput && filters.search) {
            searchInput.value = filters.search;
            if (clearBtn) {
                clearBtn.classList.toggle('hidden', filters.search.trim() === '');
            }
        }

        section.querySelectorAll('.custom-select__option').forEach((filter) => {
            filter.addEventListener('click', function (e) {
                const value = e.target.dataset.value;
                const filterKey = e.target.dataset.filter;

                filters[filterKey] = value === 'all' ? null : value;
                window.location.href = buildBlogBlockFilterUrl(filters);
            });
        });

        createSearchHandler({
            searchInput,
            clearBtn,
            filters,
            onSearch: () => {
                window.location.href = buildBlogBlockFilterUrl(filters);
            },
        });

        createSortHandler({
            popularBtn,
            recentBtn,
            filters,
            onSort: () => {
                window.location.href = buildBlogBlockFilterUrl(filters);
            },
        });
    });
});
